import { createContext } from 'react';
import { cognitoUserManager } from '@/configs/cognitoAuthConfig';
import { AUTH_STATE, type AuthContextType } from '@/types';

const defaultAuthContext: AuthContextType<typeof cognitoUserManager> = {
  state: AUTH_STATE.UNAUTHENTICATED,
  userManager: cognitoUserManager,
  userInfo: null,
  logout: () => {
    console.warn('logout called outside AuthProvider');
  },
  setAuthenticated: () => {
    console.warn('setAuth called outside AuthProvider');
  },
  setUserInfo: () => {
    console.warn('setUserInfo called outside AuthProvider');
  },
  bumpAuthEvaluation: () => {
    console.warn('bumpAuthEvaluation called outside AuthProvider');
  },
};

export const AuthContext = createContext(defaultAuthContext);
